module.exports = __webpack_public_path__ + "static/media/Matt.c7a3ddbe.jpg";